/* global google */
import {
  TerraDraw,
  TerraDrawPolygonMode,
  TerraDrawSelectMode
} from 'terra-draw'
import { TerraDrawGoogleMapsAdapter } from 'terra-draw-google-maps-adapter'

const MERGE_STYLES = {
  fillColor: '#007e80',
  fillOpacity: 0.3,
  outlineColor: '#007e80',
  outlineWidth: 2,
  outlineOpacity: 1
}

const CUT_STYLES = {
  fillColor: '#fa8d29',
  fillOpacity: 0.3,
  outlineColor: '#fa8d29',
  outlineWidth: 2,
  outlineOpacity: 1
}

export function getDrawingStyles (drawingType) {
  return drawingType === 'cut' ? CUT_STYLES : MERGE_STYLES
}

/**
 * Create a Terra Draw instance on top of a Google Maps map.
 * Uses an isolated data layer so hauler geometry on map.data is unaffected.
 */
export function createTerraDraw (map, { drawingType, onFinish } = {}) {
  const adapter = new TerraDrawGoogleMapsAdapter({
    lib: google.maps,
    map,
    isolatedData: true,
    coordinatePrecision: 9
  })

  const draw = new TerraDraw({
    adapter,
    modes: [
      new TerraDrawPolygonMode({
        styles: getDrawingStyles(drawingType)
      }),
      new TerraDrawSelectMode({
        flags: {
          polygon: {
            feature: {
              draggable: true,
              coordinates: {
                midpoints: true,
                draggable: true,
                deletable: true
              }
            }
          }
        }
      })
    ]
  })

  if (onFinish) {
    draw.on('finish', onFinish)
  }

  draw.start()
  return draw
}

export function destroyTerraDraw (draw) {
  if (!draw) return

  try {
    draw.stop()
  } catch (e) {
    // Ignore cleanup errors during teardown.
  }
}
